import './invitations.scss';

import React from 'react';
import Select from '../../components/select';
import EmailValidator from 'email-validator';
import gql from 'nanogql';
import Query from '../../query';

export default class extends React.Component {

  state = {
    invitations: [],
    name: '',
    email: '',
    group: 'Default',
    editing: false,
    groups: [
      {
        label: 'Default',
        value: 'Default'
      }
    ],
    sending: false,
    sent: false
  };

  componentDidMount() {
    this.fetchGroupNames()
      .catch(console.warn);
  }

  async fetchGroupNames() {

    const query = gql`{
        getUserPortalGroupNames
    }`;

    const result = await Query(query);

    if (!Array.isArray(result.getUserPortalGroupNames)) {
      return;
    }

    const groups = (result.getUserPortalGroupNames || [])
      .map((name) => {
        return {
          label: name,
          value: name
        }
      });

    this.setState({
      groups
    });

  }

  onGroupSelection(group) {
    this.setState({
      group
    });
  }

  edit(invitation) {
    if (this.state.name || this.state.email) {
      return;
    }
    this.setState({
      editing: invitation,
      name: invitation.name,
      email: invitation.email,
      group: invitation.group
    });
  }

  isGroupValid(group) {
    if (!group) {
      return false;
    }
    return !!this.state.groups.find((option) => option.value.toLowerCase().trim() === group.toLowerCase().trim());
  }

  canAdd() {
    return this.state.name && EmailValidator.validate(this.state.email) && this.isGroupValid(this.state.group);
  }

  allValid() {
    return !this.state.invitations.find((invitation) => !(
      invitation.name &&
      EmailValidator.validate(invitation.email) &&
      this.isGroupValid(invitation.group)
    ));
  }

  onAdd() {
    if (!this.canAdd()) {
      return;
    }

    const invitations = this.state.invitations.slice();

    const invitation = {
      name: this.state.name,
      email: this.state.email,
      group: this.state.group
    };

    if (this.state.editing) {
      const index = invitations.indexOf(this.state.editing);

      if (index === -1) {
        invitations.unshift(invitation);
      } else {
        invitations[index] = invitation;
      }
    } else {
      invitations.unshift(invitation);
    }

    this.setState({
      invitations,
      name: '',
      email: '',
      editing: false
      // Retain group so they can keep on adding
    });
  }

  async sendInvite() {
    if (this.state.editing || !this.canAdd()) {
      return;
    }

    const result = await this.sendInvites([
      {
        name: this.state.name,
        email: this.state.email,
        group: this.state.group
      }
    ], true);

    if (!result) {
      return;
    }

    await new Promise((resolve) => this.setState({
      name: '',
      email: ''
    }, resolve));
  }

  async sendInvites(invites, retainInvites = true) {

    const promise = new Promise((resolve) => this.setState({
      sending: true,
      sent: false
    }, resolve));

    const query = gql`
        mutation Mutation($input: [CreateInvitationInput]!) {
            createInvitations(input: $input)
        }
    `;

    let result;

    try {
      result = await Query(query, {
        input: invites
      });
    } catch(e) {
      result = {
        createInvitations: false
      }
    }

    console.log(result);

    await promise;

    await new Promise((resolve) => this.setState({
      sending: false,
      sent: !!result.createInvitations
    }, resolve));

    if (!result.createInvitations) {
      alert('Invitations failed to send');
      return false;
    }

    if (retainInvites) {
      return true;
    }

    await new Promise((resolve) => this.setState({
      invitations: [],
    }, resolve));

    return true;
  }

  render() {
    /*

     <button>
     Upload CSV
     </button>
     */

    return (
      <div className="invitations">
        <div className="invitations-header">
          <div className="header-wrapper">
            <h1><i className="fa fa-envelope-o"/>&nbsp;&nbsp;Invitations</h1>
            {
              this.state.sending ? (
                <div className="spinner" />
              ) : null
            }
            {
              this.state.sent || this.state.sending ? (
                <p className={`invitations-sent ${this.state.sending ? 'sending' : ''}`}>
                  Invitations sent!
                </p>
              ) : null
            }
          </div>
        </div>
        <div className="invitations-new">
          <div className="invitations-new-group">
            <label>Name</label>
            <input
              type="text"
              placeholder="Name"
              value={this.state.name}
              name="name"
              onChange={(event) => this.setState({[event.target.name]: event.target.value})}
            />
          </div>
          <div className="invitations-new-group">
            <label>Email</label>
            <input
              type="text"
              placeholder="Email"
              value={this.state.email}
              name="email"
              onChange={(event) => this.setState({[event.target.name]: event.target.value})}
            />
          </div>
          <div className="invitations-new-group">
            <label>Group</label>
            <Select
              placeholder="Select Group"
              options={this.state.groups}
              value={this.state.group}
              onChange={this.onGroupSelection.bind(this)}
            />
          </div>
          <div className="invitations-new-group invitations-new-button-group">
            <button onClick={this.onAdd.bind(this)}
                    disabled={this.state.sending || !this.canAdd()}>{this.state.editing ? 'Save' : 'Add'}</button>
          </div>
          <div className="invitations-new-group invitations-new-button-group">
            <button className="secondary" disabled={this.state.sending || this.state.editing || !this.canAdd()} onClick={this.sendInvite.bind(this)}>Send Invite</button>
          </div>
        </div>
        {
          this.state.invitations.map((invitation, index) => (
            <div className="invitation-row" key={index}>
              <span className={invitation.name ? '' : 'invalid'}>{invitation.name}</span>
              <span className={EmailValidator.validate(invitation.email) ? '' : 'invalid'}>{invitation.email}</span>
              <span className={this.isGroupValid(invitation.group) ? '' : 'invalid'}>{invitation.group}</span>
              <button
                className="border-only"
                disabled={!!(this.state.name || this.state.email)}
                onClick={this.edit.bind(this, invitation)}
              >Edit
              </button>
              <button className="border-only">Delete</button>
            </div>
          ))
        }
        {
          this.state.invitations.length ? (
            <div className="invitations-footer">
              <button disabled={this.state.sending || !this.allValid()} onClick={this.sendInvites.bind(this, this.state.invitations, false)}>Send Invite to all</button>
            </div>
          ) : null
        }
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/pages/invitations/index.js